export interface ExportRunContext {
  epoch: number;
  controller: AbortController;
}

export interface ExportRunCoordinator {
  epoch: number;
  controller: AbortController | null;
}

export const createExportRunCoordinator = (): ExportRunCoordinator => ({
  epoch: 0,
  controller: null
});

export const startExportRun = (coordinator: ExportRunCoordinator): ExportRunContext => {
  coordinator.controller?.abort();
  coordinator.epoch += 1;
  const controller = new AbortController();
  coordinator.controller = controller;
  return { epoch: coordinator.epoch, controller };
};

export const cancelExportRun = (coordinator: ExportRunCoordinator): void => {
  coordinator.epoch += 1;
  coordinator.controller?.abort();
  coordinator.controller = null;
};

export const isActiveExportRun = (
  coordinator: ExportRunCoordinator,
  run: ExportRunContext
): boolean => (
  coordinator.epoch === run.epoch
  && coordinator.controller === run.controller
  && !run.controller.signal.aborted
);

export const isExportRunCancellation = (
  coordinator: ExportRunCoordinator,
  run: ExportRunContext,
  error?: any
): boolean => (
  !isActiveExportRun(coordinator, run)
  || run.controller.signal.aborted
  || error?.name === 'AbortError'
  || error?.name === 'CanceledError'
  || error?.code === 'ERR_CANCELED'
);

/**
 * Runtime text measurement is authoritative and cannot be acknowledged as a
 * visual-layout exception. Keep its report for diagnostics, but move the UI
 * to a hard-error state so “Generate PDF anyway” is not offered again.
 */
export const exportProofFailurePhase = (
  reportStatus: 'ready' | 'blocked' | undefined,
  errorCode?: string
): 'blocked' | 'error' => (
  reportStatus === 'blocked' && errorCode !== 'PDF_TEXT_OVERFLOW'
    ? 'blocked'
    : 'error'
);
